import asyncComponent from '../common/utils/async-component';

const IndexLog = asyncComponent(async () => import('./components'));

export default {
  '/api/index-log': {
    components: { main: IndexLog }
  }
};
